import { render, staticRenderFns } from "./MemTopUp.vue?vue&type=template&id=470912bb&scoped=true"
import script from "./MemTopUp.vue?vue&type=script&lang=js"
export * from "./MemTopUp.vue?vue&type=script&lang=js"
import style0 from "./MemTopUp.vue?vue&type=style&index=0&id=470912bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470912bb",
  null
  
)

export default component.exports